import axios from "axios";
import { main_url, removeUserSession } from "../../utilis/Common";
import { getApiErrorMessage } from "../../utilis/apiErrorMessage";

export const apiUrl = axios.create({
        baseURL: main_url()+'/api/v1/',
        headers: {
            'Content-Type': 'application/json',
        },
});

apiUrl.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers) {
    delete config.headers.Authorization;
  }

  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    if (typeof config.headers?.delete === "function") {
      config.headers.delete("Content-Type");
      config.headers.delete("content-type");
    } else if (config.headers) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
  }
  return config;
});

apiUrl.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;
    if (
      error?.response?.status === 403 &&
      (data?.mfa_enrollment_required === true || data?.code === "2FA_ENROLLMENT_REQUIRED")
    ) {
      removeUserSession();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    const message = getApiErrorMessage(error);
    if (message) {
      error.userMessage = message;
    } else if (message === null) {
      error.suppressUserMessage = true;
    }
    return Promise.reject(error);
  }
);
